<template>
  <div class="container">
    <div class="row justify-content-end">
      <div class="col-md-8 col-sm-12">
        <div class="card p-md-5 p-2">
          <div class="card-body" v-html="content.txt">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StoryEnd',
  props: ['initData','contents'],
  data(){
    this.initData.bigImage = 11
  },
  computed:{
    content(){
      return this.contents.end
    },
  },
  methods:{

  }
}
</script>
<style scoped>
.container{
  max-width: 1280px;
  padding-top: 2rem;
  padding-bottom: 6rem;
}
.card{
  background-color: rgba(255,255,255,0.9);
}
.card-body a{
  color: #B40041;
  text-decoration: none;
}
</style>